import { render, staticRenderFns } from "./BuildingAndRoomStructure.vue?vue&type=template&id=6385cc80&"
import script from "./BuildingAndRoomStructure.vue?vue&type=script&lang=js&"
export * from "./BuildingAndRoomStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports